import { render, staticRenderFns } from "./Hinova.vue?vue&type=template&id=9daf1a50&scoped=true"
import script from "./Hinova.vue?vue&type=script&lang=js"
export * from "./Hinova.vue?vue&type=script&lang=js"
import style0 from "./Hinova.vue?vue&type=style&index=0&id=9daf1a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9daf1a50",
  null
  
)

export default component.exports